import React, { Component } from 'react'


export default class PartIIQuestion extends Component {
    //clicking shows hints and then solution...? 
    state = {
        clicks:0,
    }

    incrementClicks = () => {
        this.setState((prevState) => {
            const numHints = 1;
            return(
                {clicks:(prevState.clicks+1)%(numHints+1)}
                );
        })
    }

    render(){
        let {year,name,hasSolution} = this.props;
        const basename = process.env.PUBLIC_URL + "/USNCO Part II/" + year + "/q";
        const hints = "";//maybe keep them in PartII.js and import it here?
        const solution = hasSolution ? <div className = "PartIISolution"><img 
            src =  {basename+name+"-sol.png"} 
            className = {this.state.clicks>0 ? "inline-block f-1" : "hide"}
                alt = {basename + name + "-sol"}
            /></div> : "";
        let questionClass = "inline-block f-1 ";
        questionClass += hasSolution ? "format" : "";
        return (
        <div>
            <img 
                src = {basename + name + ".png"} 
                className = {questionClass}
                onClick = {this.incrementClicks}
                alt = {basename + name}
            />
            {hints}
            {solution}
        </div>
        );
    }
}